module.exports = __webpack_public_path__ + "media/images/metronic/accordion-plusminus-2abda4c55171e43c0e759252daf77d15.png";